import { Autocomplete, TextField } from "@mui/material";
import styled from "styled-components/macro";

export const CfcProviderInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const CfcProviderInfoRequiredCopy = styled.p`
  margin: 0;
  font-size: 18px;
  line-height: 28px;
  font-family: light;
  color: ${({ theme }) => theme.greyDark};
`;

export const CfcProviderInfoRequiredAsterisk = styled.span`
  color: ${({ theme }) => theme.redDark};
`;

export const CfcProviderInfoFields = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
  max-width: 574px;
`;

export const CfcProviderInfoLoading = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px;
  color: ${({ theme }) => theme.greyDark};

  svg {
    font-size: 24px;
  }
`;

export const CfcProviderAutocomplete = styled(Autocomplete<string>)`
  && {
    .MuiInput-root {
      color: ${({ theme }) => theme.blueDark};
    }
  }
`;

export const CfcProviderInfoTextField = styled(TextField)`
  && {
    .MuiInputLabel-root {
      color: ${({ theme }) => theme.blueDark};
      font-family: light;
    }

    .MuiInputBase-input.Mui-disabled {
      -webkit-text-fill-color: ${({ theme }) => theme.greyDark};
    }
  }
`;

export const CfcAccountLookupRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 12px;
`;

export const CfcAccountLookupButtonSlot = styled.div`
  margin-top: 18px;
`;

export const CfcOrderingOnBehalfCallout = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;
  width: 100%;
  height: 36px;
  padding: 0 16px;
  border-radius: 6px;
  background: #ffb545;

  svg {
    flex-shrink: 0;
    font-size: 18px;
    color: ${({ theme }) => theme.headerBackground};
  }
`;

export const CfcOrderingOnBehalfText = styled.p`
  margin: 0;
  font-family: light;
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme }) => theme.headerBackground};
`;

export const CfcOrderingOnBehalfClinic = styled.span`
  font-family: bold;
  color: ${({ theme }) => theme.headerBackground};
`;
